module.exports = __webpack_public_path__ + "img/20210906-1630910910201209.05671214.jpg";